import { createAction, props } from '@ngrx/store';
import { ITransactionResponse } from '../models/transactions.model';

export const loadTransactionsSuccessful = createAction(
  '[TransactionsSuccessful] Load TransactionsSuccessful',
  props<{ customerId: string }>()
);

export const loadTransactionsSuccessfulSuccess = createAction(
  '[TransactionsSuccessful] Load TransactionsSuccessful Success',
  props<{ response: ITransactionResponse[] }>()
);

export const loadTransactionsSuccessfulFailure = createAction(
  '[TransactionsSuccessful] Load TransactionsSuccessful Failure',
  props<{ error: Error | any }>()
);
